export const ONE_MINUTE = 60_000
export const QUARTER_HOUR = 15 * ONE_MINUTE
export const ONE_HOUR = 4 * QUARTER_HOUR
export const FOUR_HOURS = 4 * ONE_HOUR
